import { render, staticRenderFns } from "./AlertaItem.vue?vue&type=template&id=4137d805&scoped=true"
import script from "./AlertaItem.vue?vue&type=script&lang=js"
export * from "./AlertaItem.vue?vue&type=script&lang=js"
import style0 from "./AlertaItem.vue?vue&type=style&index=0&id=4137d805&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4137d805",
  null
  
)

export default component.exports